/* eslint-disable @typescript-eslint/no-unused-vars */
import { animated, useSpring } from "@react-spring/web";
import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useAppSelector, usePopupsState } from "hooks";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { onIsLPAnimationPlaying } from "redux/slices";
import { RootState } from "redux/store";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import { Star, StarContainer } from "./styles";
import { GenericPointBalance } from "../GenericPointBalance";

const starsCount = 30;
const sparkle = 5;

const starStyles = Array.from({ length: starsCount }, () => ({
	top: `${Math.random() * 100}%`,
	left: `${Math.random() * 100}%`,
	animationDelay: `${Math.random() * sparkle}s`
}));

interface LoyaltyPointsProps {
	points: number;
}

const LoyaltyPoints: React.FC<LoyaltyPointsProps> = ({ points = 0 }) => {
	const dispatch = useAppDispatch();
	const [searchParams] = useSearchParams();
	const [isAnimating, setIsAnimating] = useState(false);

	const [currentPoints, setCurrentPoints] = useState(points);

	const pointsDifference = points - currentPoints;
	const { isLinkedScopely } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const isRewardsPopupClosed = useSelector(
		(state: RootState) => state.signUpIncentive?.isRewardsPopupClosed
	);
	const { isAnyPopupOpen } = usePopupsState();

	// *Start - Avoid backend issue that increments loyalty points when reward popup is open

	const isSignUpIncentiveReady =
		isFeatureFlagEnabled(FeaturesFlags.SCOPELY_CONNECT) && isLinkedScopely
			? isRewardsPopupClosed
			: true;
	// *End

	const countAnimation = useSpring({
		//number: 100,
		from: { number: currentPoints },
		to: { number: points },
		config: {
			duration:
				pointsDifference < 0
					? 0
					: pointsDifference <= 200
					? 2000
					: Math.min(6500, pointsDifference * 10)
		},
		pause: !isAnimating,
		onRest: () => {
			setIsAnimating(false);
			dispatch(onIsLPAnimationPlaying(false));
			setCurrentPoints(points);
		}
	});

	const startAnimation = () => {
		countAnimation.number.reset();
		setIsAnimating(true);
		//confetti();
	};

	useEffect(() => {
		if (
			points !== currentPoints &&
			!(isAnyPopupOpen || searchParams.has("deeplinkId")) &&
			isSignUpIncentiveReady
		) {
			startAnimation();
		}
	}, [points, isAnyPopupOpen, isSignUpIncentiveReady]);

	return (
		<GenericPointBalance id="loyalty-point-balance">
			<StarContainer className={isAnimating ? "in" : "out"}>
				{starStyles.map((style, i) => (
					<Star key={i} style={style} />
				))}
			</StarContainer>
			{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
				<CrownIconV2 />
			) : (
				<CrownIcon />
			)}
			<animated.div style={{ zIndex: 2 }}>
				{countAnimation.number.to(
					(val) => `${Math.floor(val).toLocaleString("en-US")}`
				)}
			</animated.div>
		</GenericPointBalance>
	);
};

export default LoyaltyPoints;
